// src/pages/FaqPage.jsx
import React, {useEffect, useState} from 'react';
import '../styles/App.css';
import '../styles/Faq.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import FaqBannerSearchBar from "../components/FaqBannerSearchBar";
import {useTranslation} from "react-i18next";
import {getPath} from "../utils/functions";

function FaqPage() {
    const [t, i18n] = useTranslation();

    return (
        <div className="faq-page-wrapper">
            <Navbar />

            <FaqBannerSearchBar />
            <div className="main-container container">
                <h2 className="faq-topics-title"><img src="/Images/question-in-circle.png"
                                                      style={{width: "30px"}}/>{t('faqs.topics')}</h2>


                {/* Grid of link buttons */}
                <div id="main" className="container d-flex justify-content-evenly" style={{backgroundColor: "transparent"}}>
                    <div className="main-sections-grid">
                        <a href={getPath("/faqs/general")} className="main-section-btn">
                            {t('faqs.topic1')}
                        </a>
                        <a href={getPath("/faqs/profile-management")} className="main-section-btn">
                            {t('faqs.topic2')}
                        </a>
                        <a href={getPath("/faqs/search-and-filtering")} className="main-section-btn">
                            {t('faqs.topic3')}
                        </a>
                        <a href={getPath("/faqs/activities-details")} className="main-section-btn">
                            {t('faqs.topic4')}
                        </a>
                        <a href={getPath("/faqs/booking-schedule")} className="main-section-btn">
                            {t('faqs.topic5')}
                        </a>
                        <a href={getPath("/faqs/reviews&comments")} className="main-section-btn">
                            {t('faqs.topic6')}
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default FaqPage;
